/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import TextField, {
  TextFieldProps
} from '@material-ui/core/TextField';
import {translate} from '@ion/core/src/locale/locale';
import {IonSpinner} from '@ion/dls/src/components/loading/IonSpinner';

// defines the component style definitions ...
const useStyles = makeStyles(() => ({
  progress : {
    position : 'relative',
    right    : '40px'
  }
}));

// defines the component style definitions ...
export type JobTaskSearchInputProps = {
  isLoading: boolean;
  params: TextFieldProps;
  placeholder?: string;
}

/**
 * @internal
 *
 * Provides a Custom Search Input Field Renderer component for displaying the
 * search input field and the progress indicator when the options are being
 * loaded. This component is generally only to be used for Device File searches
 * which allow for selecting a specific field to be used for the search, in
 * which case the progress indicator will be displayed in line.
 *
 * @param   isLoading When true, the progress indicator will be displayed at
 *          the end of input field just before the dropdown toggle control.
 * @param   params the `TextFieldProps` params which are forwarded to the
 *          sub-component tree.
 */
const JobTaskSearchInput = ({
  isLoading,
  params,
  placeholder = translate('jobcreate:fields.fileName.placeholder')
}: JobTaskSearchInputProps) => {
  const classes = useStyles();
  return (
    <TextField {...params}
      placeholder={placeholder}
      InputProps={{
        ...params.InputProps,
        endAdornment : (
          <>
            {isLoading ? (
              <div className={classes.progress}>
                <IonSpinner width='15px' height='15px' />
              </div>) : null}
            {params.InputProps.endAdornment}
          </>
        )
      }}/>
  );
};
export default JobTaskSearchInput;
